export const ZOOM_LEVEL_MARGIN = 9;
export const RASTER_ZOOM_LEVEL = 11;
